import React from "react";
import { DialogRoot } from "components/ui/dialog";
import {
  DialogActionTrigger,
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@chakra-ui/react";
import { Button } from "components/ui/button";
import profileImage from "assets/img/avatars/profileImage.jpg";
import {
  localizeContractorSkills,
  localizeFacilitySize,
  localizeSupplierTypes,
} from "utils/localization";
const BASE_URL = process.env.REACT_APP_ENDPOINT;

const InfoRow = ({ label, value, children }) => {
  if (!children && (value === undefined || value === null || value === "")) {
    return null;
  }

  return (
    <div className="flex flex-wrap items-start gap-2">
      <span className="font-bold">{label}:</span>
      {children || <span>{value}</span>}
    </div>
  );
};

const UserInfo = ({ user }) => {
  const isSupplier = user?.role === "supplier";
  const businessInfo = isSupplier ? user?.supplierInfo : user?.contractorInfo;
  const roleLabel = isSupplier
    ? "مورد"
    : user?.role === "contractor"
    ? "مقاول"
    : "—";

  return (
    <DialogRoot dir="rtl">
      <DialogTrigger asChild>
        <button className="rounded-full bg-blueSecondary px-6 py-1 text-white transition-all hover:bg-brandLinear">
          بيانات المستخدم
        </button>
      </DialogTrigger>
      <DialogContent className="fixed top-1/2 -translate-x-1/2 -translate-y-1/2 bg-white text-gray-700 end-1/2 dark:bg-navy-800 dark:text-white">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold">
            بيانات المستخدم
          </DialogTitle>
        </DialogHeader>
        <DialogBody>
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-4">
              <img
                src={user?.photo ? `${BASE_URL}/${user.photo}` : profileImage}
                alt="صورة المستخدم"
                className="h-20 w-20 rounded-full border border-gray-200 object-cover"
                crossOrigin="anonymous"
              />
              <span className="text-lg font-bold">{user?.name || "—"}</span>
            </div>
            <InfoRow label="رقم الهاتف">
              <a
                className="text-blue-500 hover:underline"
                href={`tel:${user?.phoneNumber}`}
              >
                {user?.phoneNumber || "—"}
              </a>
            </InfoRow>
            <InfoRow label="نوع المستخدم" value={roleLabel} />
            {businessInfo?.email && (
              <InfoRow label="البريد الإلكتروني">
                <a
                  className="text-blue-500 hover:underline"
                  href={`mailto:${businessInfo.email}`}
                >
                  {businessInfo.email}
                </a>
              </InfoRow>
            )}
            <InfoRow
              label="اسم المؤسسة"
              value={businessInfo?.institutionName}
            />
            <InfoRow
              label="السجل التجاري"
              value={businessInfo?.commercialRegister}
            />
            {isSupplier && (
              <InfoRow label="الرقم الضريبي" value={businessInfo?.taxNumber} />
            )}
            <InfoRow
              label="رقم العضوية"
              value={businessInfo?.membershipNumber}
            />
            <InfoRow
              label="حجم المنشأة"
              value={localizeFacilitySize(businessInfo?.facilitySize)}
            />
            {isSupplier ? (
              <InfoRow
                label="أنواع التوريد"
                value={localizeSupplierTypes(businessInfo?.types)}
              />
            ) : (
              <InfoRow
                label="المهارات"
                value={localizeContractorSkills(businessInfo?.skills)}
              />
            )}
          </div>
        </DialogBody>
        <DialogFooter>
          <DialogActionTrigger asChild>
            <Button variant="outline">
              <span>إغلاق</span>
            </Button>
          </DialogActionTrigger>
        </DialogFooter>
        <DialogCloseTrigger />
      </DialogContent>
    </DialogRoot>
  );
};

export default UserInfo;
